import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
 
import {API_URL, API_VERSION} from '../../config/config';
const SERVER_API = API_URL;
const api = axios.create({
  baseURL: `${SERVER_API}/${API_VERSION}`,
});
interface TokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number; // Token expiration time in seconds
}

api.interceptors.request.use(
    async (
      config: InternalAxiosRequestConfig,
    ): Promise<InternalAxiosRequestConfig> => {
      if (config.headers?.['Require-Token'] && !config.headers['Custom-Token']) {
        const currentToken = await getToken();
        if (currentToken) {
          config.headers.Authorization = `Bearer ${currentToken}`;
        }
        delete config.headers['Require-Token'];
      } else if (config.headers['Custom-Token']) {
        config.headers.Authorization = `Bearer ${config.headers.CustomToken}`;
      }
      return config;
    },
    (error: AxiosError): Promise<AxiosError> => {
      return Promise.reject(error);
    },
  );

// Add request interceptor for token management
api.interceptors.request.use(async config => {
  const token = await localStorage.getItem('authTokenObj');
  if (token) {
    const { access_token } = JSON.parse(token);
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  return config;
});

const getToken = async (): Promise<string | null> => {
  try {
    const token = localStorage.getItem('authTokenObj');
    if (!token) return null;
    const tokenObj: TokenResponse = JSON.parse(token);
    return tokenObj.access_token;
  } catch (error) {
    console.log('Error getting token from AsyncStorage:', error);
    return null;
  }
};

const initializeAuthHeader = async () => {
  const token = await getToken();
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};

initializeAuthHeader();
 
api.interceptors.request.use(async config => {
  return config;
});

api.interceptors.response.use(
  response => response,
  async error => {
    return Promise.reject(error);
  },
);
export const refreshAccessToken = async (): Promise<TokenResponse | null> => {
  const refreshToken = localStorage.getItem('authTokenObj'); // Replace with secure storage in production
  if (!refreshToken) throw new Error('No refresh token available.');
  const tokenObj = JSON.parse(refreshToken);
  console.log('Refreshing token with:', tokenObj);
  const payload = new URLSearchParams();
  payload.append('refresh_token', tokenObj.refresh_token);
  const {data} = await api.post(
    `${SERVER_API}/${API_VERSION}/auth/refreshToken`,
    payload.toString(),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );
  const newToken: TokenResponse = data;
  console.log('Received new token:', newToken);
  localStorage.setItem('authTokenObj', JSON.stringify(newToken));
  return newToken;
};

export const apiClient = {
  get: (url: string, config?: any) =>
    api.get(url, config).then(res => res.data),
  post: (url: string, data: any, config?: any) =>
    api.post(url, data, config).then(res => res.data),
  patch: (url: string, data: any, config?: any) =>
    api.patch(url, data, config).then(res => res.data),
  put: (url: string, data: any, config?: any) =>
    api.put(url, data, config).then(res => res.data),
  delete: (url: string, config?: any) =>
    api.delete(url, config).then(res => res.data),
};
export default api;
